import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../../../../../scss/pages/workout.css";
import BenefitsComponent from "../../../details/BenefitsComponent";
import VideoComponent from "../../../details/VideoComponent";
import Header from "../../subcategory/Header";
import { useTranslation } from "react-i18next";

const Trikonasana = () => {
    const [muscleVideo, setMuscelVideo] = useState("video");
    const {t} = useTranslation();
    const contentObject = [
      { title: t("Trikonasana.title1"), context: t("Trikonasana.context1") },
      { title: t("Trikonasana.title2"), context: t("Trikonasana.context2") },
      { title: t("Trikonasana.title3"), context: t("Trikonasana.context3") },
      { title: t("Trikonasana.title4"), context: t("Trikonasana.context4") },
      { title: t("Trikonasana.title5"), context: t("Trikonasana.context5") },
      { title: t("Trikonasana.title6"), context: t("Trikonasana.context6") },
      { title: t("Trikonasana.title7"), context: t("Trikonasana.context7") }
    ];
  
  
    return (
      <>
        <Header headtitle={t("Trikonasana.title")} />
        <div className="workOutWrap">
          <div className="workoutButtonWrap">
            <Link
              to="#"
              className={muscleVideo === "video" ? "active" : null}
              onClick={() => {
                setMuscelVideo("video");
              }}
            >
              Video
            </Link>
            <Link
              to="#"
              className={muscleVideo === "benefits" ? "active" : null}
              onClick={() => {
                setMuscelVideo("benefits");
              }}
            >
              Benefits
            </Link>
          </div>
          <div className="videoWrapper">
            {muscleVideo === "video" ? (
              <VideoComponent
                workoutVideo={'https://tickhigh.s3.ca-central-1.amazonaws.com/Wellness360/Yoga/Trikonasana.mp4'}
                title="Description"
                context={t("Trikonasana.description")}
                muscleTitle={false}
                muscleImg={false}
              />
            ) : (
              <BenefitsComponent
                context=""
                title="Description"
                benfits={false}
                contentObj={contentObject}
              />
            )}
          </div>
        </div>
      </>
    );
  };

export default Trikonasana
